import { render, staticRenderFns } from "./garage-success.vue?vue&type=template&id=8be99e70&scoped=true&"
import script from "./garage-success.vue?vue&type=script&lang=js&"
export * from "./garage-success.vue?vue&type=script&lang=js&"
import style0 from "./garage-success.vue?vue&type=style&index=0&id=8be99e70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be99e70",
  null
  
)

export default component.exports